export enum CopyType {
  Copy = `copy`,
  Link = `link`,
}
